import VueTheMask from 'vue-the-mask'
import ReValidate from './../re-validation'
import props from './../../../../props/inputs'

const validationAttrs = [
  'validations',
  'validator',
  'groupClass',
  'groupErrorClass',
  'errorClass',
  'tabindex',
  'customErrors',
  'vRoot',
  'v'
]

export default {
  name: 're-mask-input',
  components: {
    VueTheMask,
    [ReValidate.name]: ReValidate
  },
  props: {
    ...props,
    mask: {
      type: [String, Array],
      required: true
    }
  },
  data() {
    return {
      maskInput: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.maskInput = newValue
    },
    maskInput(newVal) {
      this.$emit('input', newVal)
    }
  },
  computed: {
    maskClass() {
      return this.inputClass + ' ' + (this.inputErrorClass || '')
    },
    validationAttrs() {
      return {
        ..._.pick(this.$props, validationAttrs),
        value: this.maskInput,
        tabindex: null
      }
    }
  },
}
